import "./Footer.css";

import { FaFacebookF, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { IoLogInOutline } from "react-icons/io5";
import { FiHeadphones } from "react-icons/fi";
import { Tooltip } from "antd";

import meucontador from "../../../imagens/logo.svg"

export function Footer() {
    return (
        <>
            <div className="footer-content-inner">
                <footer>
                    <div class="container">
                        <div className="row">
                            <div className="item wid-resp">
                                <p>
                                    <figure className="image-logo-mco">
                                        <img src={meucontador} alt="Meu Contador Online" title="Meu Contador Online" width="200" height="58" loading="lazy" />
                                    </figure>
                                </p>

                                <address>
                                    <p>
                                        <a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="mailto:contato@meucontadoronline.com.br" target="_blank" title="Fale com o Meu Contador Online através do e-mail: contato@meucontadoronline.com.br">contato@meucontadoronline.com.br</a>
                                    </p>

                                    <p>
                                        <a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="tel:08000420627" target="_blank">0800 042 0627</a>
                                    </p>

                                    <a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.google.com/maps/dir//meu+contador+online/@-23.6526679,-46.5722401,13z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x94ce42796cb716dd:0xb0a04ddb381cf1a5!2m2!1d-46.5372207!2d-23.6526718" target="_blank">
                                        <p >R. das Figueiras, 474 - 8º Andar<br />B. Jardim, Santo André-SP, 09080-300</p>
                                    </a>
                                </address>

                            </div>

                            <nav class="item width-resp">
                                <h3 style={{ fontWeight: 400 }}>A EMPRESA</h3>
                                <ul>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/contabilidade-online/sobre-nos">Sobre nós</a></li>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/trabalhe-conosco">Trabalhe conosco </a></li>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/blog">Blog </a></li>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/politica-de-privacidade">Política de Privacidade</a></li>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/ouvidoria">Ouvidoria</a></li>
                                </ul>
                            </nav>

                            <nav class="item width-resp">
                                <h3 style={{ fontWeight: 400 }}>CONTABILIDADE</h3>
                                <ul>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/contabilidade-online/contabilidade-online" >Contabilidade Online</a></li>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/contabilidade-online/abrir-empresa-online" >Abrir Empresa  </a></li>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/trocar-de-contabilidade" >Trocar de Contabilidade </a></li>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/transformar-mei-em-me" >Migrar MEI para ME </a></li>
                                    <li className="font-w-margin-b"><a style={{ color: "#fff", fontSize: 14, textDecoration: "none" }} href="https://www.meucontadoronline.com.br/consulta-cnae" >Consulta CNAE </a></li>
                                </ul>
                            </nav>

                            <div className="item">
                                <div className="d-flex">
                                    <a href="https://portal.meucontadoronline.com.br/portal/#PortalLogin" target="_blank">
                                        <div className="d-flex-a">
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", color: "#fff", fontSize: 14, marginRight: 2, position: "relative", top: 2 }}>
                                                <IoLogInOutline style={{ color: "#fff", fontSize: 16 }} />
                                            </div>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", color: "#fff", fontSize: 14, position: "relative", top: 2 }}>LOGIN</div>
                                        </div>
                                    </a>

                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", color: "#fff", fontSize: 24 }}>
                                        <a className="btn-planos" href="https://www.meucontadoronline.com.br/trocar-contabilidade#planos">
                                            Planos
                                        </a>
                                    </div>
                                </div>
                                <div>
                                    <ul className="display-icon">
                                        <li className="li-hover">
                                            <a style={{ color: "#fff" }} target="_blank" href="https://www.facebook.com/meucontadoronline" aria-label="Facebook do Meu Contador Online">
                                                <FaFacebookF />
                                            </a>
                                        </li>
                                        <li className="li-hover">
                                            <a style={{ color: "#fff" }} target="_blank" href="https://www.instagram.com/meucontadoronline" aria-label="Instagram do Meu Contador Online">
                                                <FaInstagram />
                                            </a>
                                        </li>
                                        <li className="li-hover">
                                            <a style={{ color: "#fff" }} target="_blank" href="https://www.youtube.com/meucontadoronline" aria-label="YouTube do Meu Contador Online">
                                                <FaYoutube />
                                            </a>
                                        </li>
                                        <li className="li-hover">
                                            <a style={{ color: "#fff" }} target="_blank" href="https://www.linkedin.com/company/meu-contador-online/?viewAsMember=true" aria-label="LinkedIn do Meu Contador Online">
                                                <FaLinkedinIn />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="line-hr">
                            <hr />
                        </div>

                        <aside>
                            <div className="container-ouvidoria">
                                <div className="ouvidoria">
                                    <a href="tel:+5508006006002" style={{ color: "#000000ff", fontSize: 14, textDecoration: "none" }}>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", fontSize: 28, padding: 10 }}>
                                                <Tooltip title="Ouvidoria Meu Contador Online">
                                                    <a href="https://www.meucontadoronline.com.br/assets/imagens/headset.svg" style={{ color: "black" }} aria-label="Ouvidoria">
                                                        <FiHeadphones />
                                                    </a>
                                                </Tooltip>
                                            </div>
                                            <div style={{ fontSize: 16 }}>
                                                <span>
                                                    <strong title="Ligue para Ouvidoria 0800 600 6002" style={{ letterSpacing: 2 }}>OUVIDORIA</strong><br />
                                                    <span style={{ fontWeight: 300 }}>0800 600 6002</span>
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="ouvidoria-text">
                                    <p>
                                        Conforme determinação legal, as atividades contábeis são prestadas unicamente pela empresa MEU CONTADOR CONTABILIDADE através de seus contadores. A MEU CONT ONLINE LTDA é a empresa que fornece soluções de software e serviços de apoio administrativo. "MEU CONTADOR ONLINE" utilizado neste site faz referência ora à MEU CONTADOR CONTABILIDADE LTDA ora à MEU CONT ONLINE LTDA, as quais atuam em parceria e atendem a todas as exigências legais. Conselho Regional de Contabilidade – 2SP036436
                                    </p>
                                </div>
                            </div>
                        </aside>
                    </div>
                </footer>
            </div>
        </>
    );
}
